import React, { Component } from "react";
import Table from "react-bootstrap/Table";
import { OrderRequestFiles } from "../../request-details-files.component";
import { RequestOnBehalfDetails } from "../../request-on-behalf-details.component";
import Translation from "../../../../../common/translation/translation.component";
import { ORDER_STATUS, CIRCUIT_STATUS } from "../../../../../../constants/external-constants";
import Icons from "../../../../../icon";
import { convertToDate, toYesOrNo } from '../../../../../../utils/helpers.utils';
import FormatDate from "../../../../../common/date/format-date.component";

export class WirelineChangeVendorDetails extends Component {
    constructor(props) {
        super(props);
    }

    //renderPlanComponents = props => {
    //    return props != null && props.length != 0
    //        ? props.map((item, i) => (
    //            <tr key={i}>
    //                <td>{i === 0 ? "Plan Details" : null}</td>
    //                <td>{item.ComponentName}</td>
    //            </tr>
    //        ))
    //        : null;
    //};


    editRequest = (orderStatusId, endUserId, requestorId, path) => {
        const editableRequest = (orderStatusId === ORDER_STATUS.waitingForAuthorization || orderStatusId === ORDER_STATUS.open);

        var employeeId = sessionStorage.getItem('EmployeeID');
        const isRequestOwner = (endUserId == employeeId) || (requestorId == employeeId);

        return editableRequest && isRequestOwner && !path;
    }

    render() {
        const { data, isWireline, openRequestModal, path } = this.props;
        const {Order: { RequestType: { RequestTypeID, RequestType }, OrderStatusId, EndUserId, RequestorId }} = data || {};
        return (
            <div>                
                <h4 className="order-detail-title"><Translation translationKey="order_request_details" />
                    {this.editRequest(OrderStatusId, EndUserId, RequestorId, path) ?  
                            <>
                            <Icons
                                customClassName="pen-to-square"
                                name="pen-to-square"
                                size="20px"
                                containerClass="icon-circle-plus-container"
                                onClick={() =>{openRequestModal(RequestTypeID, RequestType)}} 
                                labelValue={"Update Order Request"}
                                labelClass="order-detail-edit-label"                                                              
                            />
                            </>
                            : null 
                    }

                </h4>
                <div className="order-detail-location">
                    <div className="order-detail-number-container mb-0">
                        <div className="order-title">
                            <Translation translationKey="order_number" />
                        </div>
                        <div className="order-label">
                            {data.Order.OrderNumber}
                        </div>
                    </div>    

                    <RequestOnBehalfDetails robDetails={data.RequestedInBeHalfOf} isRob={data.Order.IsRequestedInBehalf} />                  
                   
                    <h5 className="order-detail-location-title"><Translation translationKey="subscription_upper" /></h5>
                    <Table>
                        <tbody>
                            <tr>
                                <td><Translation translationKey="subscription_number" /></td>
                                <td>{data.Circuit.CircuitCode}</td>
                            </tr>
                            <tr>
                                <td></td>
                                <td className={data.Subscription.CircuitStatus == CIRCUIT_STATUS.inService.name ? "status-inservice" :
                                              data.Subscription.CircuitStatus == CIRCUIT_STATUS.suspended.name ? "status-suspended" : ""} >{data.Subscription.CircuitStatus}</td>
                            </tr>
                            <tr>
                                <td></td>
                                <td>{data.Subscription.OldVendorDetailName}</td>
                            </tr>
                            <tr>
                                <td></td>
                                <td>{data.Subscription.CircuitType}</td>
                            </tr>
                            <tr>
                                <td></td>
                                <td>{data.Subscription.SubCircuitType}</td>
                            </tr>
                        </tbody>
                    </Table>
                    <h5 className="order-detail-location-title"><Translation translationKey="change_new_vendor_capital" /></h5>
                    <Table>
                        <tbody>
                            <tr>
                                <td><Translation translationKey="new_vendor" /></td>
                                <td>{data.NewRequest.Vendor && data.NewRequest.Vendor.VendorName}</td>
                            </tr>
                            <tr>
                                <td><Translation translationKey="new_billing_account" /></td>
                                <td>{data.NewRequest.Account.AccountNumber}</td>
                            </tr>
                            <tr>
                                <td><Translation translationKey="approver" /></td>
                                <td>{data.WireLineApprover?.Email}</td>
                            </tr>

                            <tr>
                                <td><Translation translationKey="need_by_date" /></td>
                                <td>
                                    <FormatDate date={convertToDate(data.Order.NeedByDate)} />
                                </td> 
                            </tr>
                            <tr>
                                <td><Translation translationKey="expedite_request" /></td>
                                <td>{toYesOrNo(data.BusinessWireline.ExpediteRequest)}</td>
                            </tr>
                            <tr>
                                <td><Translation translationKey="business_justification" /></td>
                                <td>{data.BusinessJustification.BusinessJustification}</td>
                            </tr>
                            <tr>
                                <td><Translation translationKey="additional_information" /></td>
                                <td>{data.BusinessJustification.AdditionalInformation}</td>
                            </tr>

                        </tbody>
                    </Table>
                    {isWireline &&
                        <OrderRequestFiles files={data.Order.OrderFileNames} />
                    }
                </div>
            </div>
        );
    }
}